<template>
  <div style="margin: 10px">
    <v-btn fab color="#2722a6" v-b-modal.add-team-member>
      <v-icon large color="white">mdi-plus</v-icon>
    </v-btn>
    <v-alert
      v-if="canViewInactiveRoster && !rosterStatusApiReady"
      type="warning"
      dense
      outlined
      class="mx-3 mb-3"
    >
      <strong>Roster status is not saved yet.</strong> This CMS is talking to an
      API that does not return <code>is_currently_working</code> (production
      until nekoapi migration <code>0058</code> is deployed). Badges and the
      edit checkbox only update the screen until the API is upgraded. Use a
      local Django nekoapi with
      <code>VUE_APP_API_BASE_URL=http://127.0.0.1:8000/</code> to test
      persistence.
    </v-alert>
    <v-alert
      v-else-if="canViewInactiveRoster"
      type="info"
      dense
      outlined
      class="mx-3 mb-3"
      color="blue lighten-4"
    >
      <strong>Team roster (Liam only):</strong> click <strong>Working</strong> /
      <strong>Not working</strong> to hide someone from default lists (Timer,
      etc.). For staff who are still here but leaving soon, use
      <strong>Edit Card</strong> →
      <strong>Hide from Koneko A from month</strong> (e.g.
      <code>2026-06</code> for Adam Eba and Owen Bennett).
    </v-alert>
    <b-modal
      id="add-team-member"
      scrollable
      centered
      title="Team Member Form"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <add-team-form modalId="add-team-member" />
    </b-modal>
    <b-row class="m-1">
      <v-col>
        <template v-if="workingMembers.length">
          <h4 class="ml-4 mt-2 white--text">Currently working</h4>
          <v-row class="m-2" justify="start">
            <v-col
              v-for="member in workingMembers"
              :key="member.id"
              lg="3"
              md="6"
            >
              <team-top-card
                :team="member"
                :publishFlag="member.publish"
                v-on:child-to-parent-teams="onChildClick"
                modalId="team-detail"
                class="mx-auto"
                editModalId="edit-team-detail"
              />
            </v-col>
          </v-row>
        </template>
        <template v-if="notWorkingMembers.length">
          <h4 class="ml-4 mt-4 white--text">Not currently working</h4>
          <v-row class="m-2" justify="start">
            <v-col
              v-for="member in notWorkingMembers"
              :key="'nw-' + member.id"
              lg="3"
              md="6"
            >
              <team-top-card
                :team="member"
                :publishFlag="member.publish"
                v-on:child-to-parent-teams="onChildClick"
                modalId="team-detail"
                class="mx-auto"
                editModalId="edit-team-detail"
              />
            </v-col>
          </v-row>
        </template>
      </v-col>

      <b-modal id="team-detail" scrollable centered hide-footer>
        <view-team-detail :team-detail="teamDetailModal" />
      </b-modal>
      <b-modal
        id="edit-team-detail"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="xl"
        scrollable
        centered
      >
        <edit-team-detail
          :team-detail="teamDetailModal"
          modalId="edit-team-detail"
        />
      </b-modal>
    </b-row>
  </div>
</template>
<script>
import TeamTopCard from "@/components/Team/TeamTopCard";
import AddTeamForm from "@/components/Team/AddTeamForm";
import ViewTeamDetail from "@/components/Team/ViewTeamDetail.vue";
import EditTeamDetail from "@/components/Team/EditTeamDetail.vue";
import {mapActions, mapGetters} from "vuex";
import {userCanViewInactiveTeamMembers} from "@/Utilites/teamRosterAdmin";
import {teamRosterStatusSupported} from "@/Utilites/teamRosterApi";

export default {
  name: "ViewTeams",
  components: {
    "team-top-card": TeamTopCard,
    "add-team-form": AddTeamForm,
    "view-team-detail": ViewTeamDetail,
    "edit-team-detail": EditTeamDetail,
  },
  data() {
    return {
      teamDetailModal: {},
      show: true,
    };
  },
  mounted() {
    this.loadContent();
  },
  computed: {
    ...mapGetters(["getTeamList", "userProfileData"]),
    workingMembers() {
      return (this.getTeamList || []).filter(
        (m) => m.is_currently_working !== false
      );
    },
    notWorkingMembers() {
      if (!this.canViewInactiveRoster) return [];
      return (this.getTeamList || []).filter(
        (m) => m.is_currently_working === false
      );
    },
    canViewInactiveRoster() {
      return userCanViewInactiveTeamMembers(this.userProfileData);
    },
    rosterStatusApiReady() {
      return teamRosterStatusSupported(this.getTeamList);
    },
  },
  methods: {
    ...mapActions(["fetchTeamList", "showLoadingProcess", "closeLoading"]),
    async loadContent() {
      await this.showLoadingProcess();
      try {
        await this.fetchTeamList({
          includeNotWorking: userCanViewInactiveTeamMembers(
            this.userProfileData
          ),
        });
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },
    showMemberDetail(item, index, button) {
      this.teamDetailModal.title = `Row index: ${index}`;
      this.teamDetailModal.content = JSON.stringify(item, null, 2);
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("bv::show::modal", this.teamDetailModal.id, button);
    },
    resetTeamDetailModal() {
      this.teamDetailModal.title = "";
      this.teamDetailModal.content = "";
    },
    showSkillSheet(item, index, button) {
      // TODO: Warning: Unresolved variable skillSheetModal - should this be declared in data()?
      this.skillSheetModal.title = `Row index: ${index}`;
      this.skillSheetModal.content = JSON.stringify(item, null, 2);
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("bv::show::modal", this.skillSheetModal.id, button);
    },
    resetSkillSheetModal() {
      this.skillSheetModal.title = "";
      this.skillSheetModal.content = "";
    },
    showTimeSheet(item, index, button) {
      this.timeSheetModal.title = `Row index: ${index}`;
      this.timeSheetModal.content = JSON.stringify(item, null, 2);
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("bv::show::modal", this.timeSheetModal.id, button);
    },
    resetTimeSheetModal() {
      this.timeSheetModal.title = "";
      this.timeSheetModal.content = "";
    },
    onChildClick(value) {
      this.teamDetailModal = value;
    },
  },
};
</script>
<style scoped></style>
